export default __webpack_public_path__ + "static/media/supper_apps_background_s2.4ec486ba.jpg";